export default {
  computed: {
    backgroundColorL () {
      if (this.backgroundColor === undefined) {
        switch (this.caseStatus) {
          case 'green':
            return '#b8e2cc'
          case 'blue':
            return '#b4dceb'
          case 'yellow':
            return '#fdfbc3'
          case 'red':
            return '#e2b8b8'
          case 'grey':
            return '#e7e7de'
        }
      }
      return this.backgroundColor
    },
    caseTextColor () {
      if (this.textColor === undefined) {
        switch (this.caseStatus) {
          case 'green':
            return '#126263'
          case 'blue':
            return '#2a7996'
          case 'yellow':
            return '#aa7308'
          case 'red':
            return '#e2b8b8'
          case 'grey':
            return '#707070'
        }
      }
      return this.textColor
    }
  }
}
